import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { DATA } from '../data/urunler-data';

import LinkComponent from '../components/LinkComponent';

import "yet-another-react-lightbox/styles.css";
import InnerSystemComponent from '../components/InnerSystemComponent';

const Sistemler = () => {

    const { id1 } = useParams();


    const category = DATA.find(category => category.link === id1);

    if (!category) {
        return <div>Bu kategoride sistem bulunamadı.</div>;
    }






    return (
        <div className='flex flex-col bg-white'>
            <LinkComponent />
            <InnerSystemComponent data={category}  category={category} id1={id1}/>
        </div>
    );
};

export default Sistemler;
